import React from "react";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Footer extends React.Component {
    render() {
        return (
            <footer className="app-footer">
                <Grid container justify="center" alignItems="center">
                    <Grid item xs={4} >
                        <Typography variant="subtitle1" >© АВТОМОБИЛЬНОСТЬ</Typography>
                        <Typography variant="subtitle1" >Все права защищены</Typography>
                        <Typography variant="subtitle1" >Соглашение о конфиденциальности</Typography>
                    </Grid>
                    <Grid item xs={4} >
                        <Typography variant="subtitle1" align="right">Контакты:</Typography>
                        <Typography variant="subtitle1" align="right">Санкт-Петербург, Новочеркасский пр., д. 1</Typography>
                        <Typography variant="subtitle1" align="right">EMAIL: INFO@ZALOG.AM</Typography>
                    </Grid>
                </Grid>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js